import { FAQ_QUERYResult } from '@/__sanity_generated__/typegen'
import { getImageUrlFor } from '@/lib/sanity'
import { PortableText, PortableTextComponents } from '@portabletext/react'
import clsx from 'clsx'
import { useState } from 'react'
import { Accordion, Actionable, Text, View } from 'reshaped'
import styles from './index.module.css'

const components: PortableTextComponents = {
  types: {
    image: ({ value }) => <img src={getImageUrlFor(value).auto('format').url()} />,
  },
  marks: {
    strong: ({ children }) => (
      <Text as="strong" weight="semibold">
        {children}
      </Text>
    ),
  },
  list: {
    bullet: ({ children }) => <ul style={{ listStyle: 'inside' }}>{children}</ul>,
  },
  listItem: {
    bullet: ({ children }) => <li>{children}</li>,
  },
}

export function FAQ({ faq }: { faq: FAQ_QUERYResult }) {
  const [activeValue, setActiveValue] = useState<string | null | undefined>(null)
  console.log(faq)
  return (
    <View paddingInline={{ s: 6, m: 0 }} gap={6} maxWidth="738px">
      {faq?.faqItem?.map((question) => (
        <View
          key={question.slug?.current}
          animated
          borderRadius="large"
          padding={4}
          borderColor="neutral-faded"
        >
          <Accordion
            active={activeValue === question.slug?.current}
            onToggle={(active) => setActiveValue(active ? question.slug?.current : null)}
          >
            <Accordion.Trigger>
              {(attributes, { active }) => (
                <Actionable attributes={attributes} fullWidth>
                  <View direction="row" gap={3} align="center">
                    <View.Item grow>
                      <Text color="primary" variant="featured-2" weight="semibold">
                        {question.title}
                      </Text>
                    </View.Item>
                    <View.Item>
                      <div
                        className={clsx(
                          styles.toggle,
                          active ? styles.active : undefined
                        )}
                      />
                    </View.Item>
                  </View>
                </Actionable>
              )}
            </Accordion.Trigger>
            <Accordion.Content>
              {question.content && (
                <View gap={1} paddingBlock={3}>
                  <PortableText value={question.content} components={components} />
                </View>
              )}
            </Accordion.Content>
          </Accordion>
        </View>
      ))}
    </View>
  )
}
